import { useNavigate } from "react-router-dom";
import { useState } from "react";

function Btn({
  BtnText = "Click here",
  BtnText2 = "Redirecting",
  redirectTo = "/",
  scrollTo = "",
}) {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();

  const handleMouseLeave = () => setClicked(false);

  const handleClick = () => {
    setClicked(!clicked);

    if (scrollTo) {
      const targetElement = document.querySelector(scrollTo);
      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    } else if (redirectTo) {
      setTimeout(() => {
        navigate(redirectTo);
      }, 500);
    }
  };

  return (
    <div className="">
      <style>
        {`
          .circle {
            transition: width 0.7s cubic-bezier(1, 1, 0.1, 1);
          }
          .btn.clicked .circle {
            width: 155%;
          }
        `}
      </style>

      <div className="flex justify-center items-center font-semibold">
        <button
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
          className={`btn relative flex bg-white overflow-hidden z-10 cursor-pointer hover:border-[#60a5fa] ${
            clicked ? "clicked hovered" : ""
          } w-40 h-10 rounded-[17.5vw] border-2 md:w-[14vw] md:h-[3.5vw] md:rounded-[5vw] md:border-[0.25vw]`}
        >
          <span className="circle bg-white z-30 ml-[-35vw] w-[35vw] h-10 md:ml-[-10vw] md:w-[10vw] md:h-[3vw]">
            <span className="text w-full h-full flex items-center justify-end z-30 text-[4.375vw] pr-[17.5%] md:text-[1.25vw] md:pr-[5%]">
              {BtnText2}
            </span>
          </span>
          <span className="bg-white z-30 overflow-hidden w-9 h-9 rounded-[17.5vw] md:w-[3vw] md:h-[3vw] md:rounded-[5vw]">
            <img
              src="/BtnArrow.jpg"
              alt="Btn arrow"
              className="w-full h-full object-cover"
            />
          </span>

          <span className="w-full absolute h-full flex items-center justify-center z-20 pl-8 text-md md:pl-[3vw] md:text-[1.25vw]">
            {BtnText}
          </span>
        </button>
      </div>
    </div>
  );
}

export default Btn;
